import React from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';

export default function RecordedTranscriptionRecovery({ recovery, busy, onRetrySave, onCheckResult }) {
  if (!recovery) return null;
  const canSave = recovery.status === 'save_pending' && Boolean(recovery.transcription);
  return <Alert severity="warning" sx={{ mb: 2 }}>
    <Typography variant="body2">
      {canSave
        ? (recovery.resultPersisted === false
          ? 'Your transcription is ready but server storage failed. Keep this page open and retry saving; refreshing may lose the text.'
          : 'Your transcription is ready but has not been saved to Files. Retry saving will not transcribe or charge again.')
        : (recovery.message || 'The result has not been confirmed. Check result retrieves this operation without transcribing or charging again. Your saved audio is still available.')}
    </Typography>
    {!canSave && <Button disabled={busy || !onCheckResult} onClick={onCheckResult} sx={{ mt: 1 }}>Check result</Button>}
    {recovery.operationId && <Typography variant="caption" sx={{ display: 'block', overflowWrap: 'anywhere' }}>Operation: {recovery.operationId}</Typography>}
    {canSave && <>
      <Button disabled={busy} onClick={onRetrySave} sx={{ mt: 1 }}>Retry saving</Button>
      <Box component="details" sx={{ mt: 1 }}>
        <Box component="summary" sx={{ cursor: 'pointer' }}>View returned transcript</Box>
        <Typography component="pre" variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', maxHeight: 240, overflow: 'auto' }}>
          {recovery.transcription}
        </Typography>
      </Box>
    </>}
  </Alert>;
}
